import { abyssColors } from '@/theme/colors';
import { Paper, Typography, alpha } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const reviewTabStyles = {
  p: 4,
  mt: 2,
  position: 'relative',
  height: 'calc(65vh / var(--zoom) - 65px)',
  justifyContent: 'center',
  background: abyssColors.neutral[50],
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
};

export const TickLabel = muiStyled(Typography)(() => ({
  fontSize: '1.6rem',
  fontWeight: 500,
  color: abyssColors.primary[500],
}));

export const CellText = muiStyled(Typography)(() => ({
  fontSize: '1.3rem',
  lineHeight: 'normal',
  color: 'rgba(0,0,0,0.87)',
}));

export const Cell = muiStyled(Paper)(({ color }: { color: string }) => ({
  aspectRatio: '15 / 16',
  width: '100%',
  backgroundColor: color,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'none',
}));
